function getParameterByName(name) {
	var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
	return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export function initialiseSearchTagging(data) {
	if (!data || !data.userInputText) return;

	try {
		let isNoSearchResultsPage = false;
		let landingPageType = 'unknown';

		const ddPageType = window.digitalData?.page?.pageInfo?.pageType;
		const pageTypes = ['Product Page', 'Lister Page', 'Lister Page Mobile'];

		// Check for "no results" page (this isn't tagged in digitalData pageType)
		const listerNoResultsNode =
			document.querySelector('.lister__no-results-page') ||
			document.querySelector('[data-page-type="no-results-page"]') ||
			document.querySelector("[data-ng-if='isInNoResultsViewMode()']");

		if (listerNoResultsNode) isNoSearchResultsPage = true;

		// Landing Page
		if (ddPageType) {
			pageTypes.forEach((pageType) => {
				if (ddPageType === pageType) landingPageType = pageType;
			});
		}

		// Landing Page: Search
		if (
			getParameterByName('search') ||
			getParameterByName('suche') ||
			getParameterByName('zoeken')
		) {
			landingPageType = isNoSearchResultsPage
				? 'No Results Page'
				: 'Search Result';
		}

		// Landing Page: Redirect
		if (getParameterByName('cmredirectionvalue')) {
			landingPageType = 'Redirect';
		}

		const getSuggestedProducts = () => {
			const { suggestedProducts } = data;

			if (!suggestedProducts) return null;

			const suggestedProductsArr = JSON.parse(suggestedProducts);

			let suggestedProductsString = '';

			if (suggestedProductsArr !== null && suggestedProductsArr.length) {
				for (let index = 0; index < suggestedProductsArr.length; index++) {
					suggestedProductsString +=
						index +
						1 +
						'|' +
						suggestedProductsArr[index].Title.toString().split(',').join(' ') +
						'|' +
						suggestedProductsArr[index].Price.toString().split(',').join('.');
					if (index !== suggestedProducts.length - 1) {
						suggestedProductsString += ',';
					}
				}

				return suggestedProductsString;
			}

			return null;
		};

		const digitalDataObj = {
			page: {
				siteSearch: {
					originPage: data.originPage,
					searchTerm: data.userInputText,
					numberOfResults: data.resultCount,
					predictiveTextSelected: data.predictiveText,
					actionResult: `${data.actionResult}|${landingPageType}`,
					searchBarVariant: data.searchBarVariant,
					suggestedProducts: getSuggestedProducts(),
				},
			},
		};

		if (window.digitalDataProxy && window.digitalDataProxy.sendBeacon) {
			window.digitalDataProxy.manipulateDigitalData(digitalDataObj);

			window.digitalDataProxy.sendBeacon('searchTermTriggered');
		}

		// Clear session storage items
		sessionStorage.removeItem('searchOriginPage');
		sessionStorage.removeItem('searchUserInputText');
		sessionStorage.removeItem('searchResultCount');
		sessionStorage.removeItem('searchPredictiveText');
		sessionStorage.removeItem('searchActionResult');
		sessionStorage.removeItem('searchBarVariant');
		sessionStorage.removeItem('searchSuggestedProducts');
	} catch (error) {
		// console.log(error);
		throw new Error(error);
	}
}

window.addEventListener('load', function () {
	initialiseSearchTagging({
		originPage: sessionStorage.getItem('searchOriginPage') || 'unknown',
		userInputText: sessionStorage.getItem('searchUserInputText') || '',
		resultCount: sessionStorage.getItem('searchResultCount') || 0,
		predictiveText: sessionStorage.getItem('searchPredictiveText') || '',
		actionResult: sessionStorage.getItem('searchActionResult') || 'unknown',
		searchBarVariant: sessionStorage.getItem('searchBarVariant' || 'unknown'),
		suggestedProducts: sessionStorage.getItem(
			'searchSuggestedProducts' || null
		),
	});
});
